// extracted by mini-css-extract-plugin
export default {"info":"btgMDbKD","list":"VZNplydM","listItem":"VQ5y1joM","initial":"HxCjxMZV","icon":"Is3TiFra","error":"Vgpencj7","valid":"ZNx1CE9E"};